import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { MENU_TOKEN, MenuService } from '@awp/app-common';
import { CurrentMenuQuery } from '@awp/content-router';
import { MenuItem } from '@awp/models';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'ap-nav-menu-widget',
  templateUrl: './nav-menu-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavMenuWidgetComponent implements OnDestroy{

  currentMenu: MenuItem;
  public menuItems: Observable<MenuItem[]>;

  constructor(
    currentMenuQuery: CurrentMenuQuery,
    @Inject(MENU_TOKEN) menuService: MenuService) {

    this.menuItems = menuService.values.pipe(
      map(p => {
        return p.filter(x => !x.hideInNav);
      }),
      shareReplay()
    );

    currentMenuQuery.values
      .pipe(
        distinctUntilChanged(),
        untilDestroyed(this))
      .subscribe(menu => {
        this.currentMenu = menu;
      });
  }

  ngOnDestroy(): void { }
}
